import styles from "assets/jss/styles";

const mainStyle = (theme) => {
  const { containerFluid } = styles(theme);
  const { container, content, contentHeader, contentFooter, footer } = theme?.main;
  return {
    container: {
      ...container,
      ...containerFluid,
      paddingLeft: "0px",
      paddingRight: "0px",
      "@media (max-width: 768px)": {
        overflowX: "hidden",
        overflowY: "auto",
        height: "100vh",
      },
    },
    content: (props) => {
      const style =
        props.showFooter || props.showHeader ? { overflow: "auto", overflowX: "hidden", padding: 10 } : { padding: 10 };
      let height = `${content.height}`;
      if (props.showHeader) height += ` - ${contentHeader?.height}`;
      if (props.showFooter) height += ` - ${contentFooter?.height}`;
      return {
        ...style,
        height: `calc(${height})`,
      };
    },
    contentHeader,
    contentFooter,
    footer: () => {
      return {
        ...footer,
        ...contentFooter,
        "@media (max-width: 768px)": {
          bottom: "-8.5px",
        },
      };
    },
  };
};

export default mainStyle;
